/* eslint-disable import/prefer-default-export */
// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { ResponseQueue } from 'types/response_queue'

export async function listResponseQueue(
  requestParams: any
): Promise<ResponseQueue[]> {
  return makeGetRequest(`${ApiBase}/response_queue`, requestParams)
}
